import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { SnackbarProvider, useSnackbar } from 'notistack';

import style from './style.module.scss';

const Actions = ({ id }) => {
  const { closeSnackbar } = useSnackbar();
  return (
    <IconButton
      className={style.action}
      onClick={() => {
        closeSnackbar(id);
      }}
      size={'small'}
    >
      <CloseIcon />
    </IconButton>
  );
};

const CustomSnackbarProvider = ({ children }) => {
  return (
    <SnackbarProvider
      className={style.snackbar}
      classes={{
        variantSuccess: style.success,
        variantError: style.error,
        variantWarning: style.warning,
        variantInfo: style.info,
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      hideIconVariant
      autoHideDuration={5000}
      action={(key) => <Actions id={key} />}
    >
      {children}
    </SnackbarProvider>
  );
};

export default CustomSnackbarProvider;
